type EventCallback<T> = (payload: T) => void;

export class EventEmitter<T extends Record<string, any>> {
  private listeners: { [K in keyof T]?: EventCallback<T[K]>[] } = {};

  on<K extends keyof T>(event: K, callback: EventCallback<T[K]>): void {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event]!.push(callback);
  }

  off<K extends keyof T>(event: K, callback: EventCallback<T[K]>): void {
    this.listeners[event] = this.listeners[event]?.filter(
      (cb) => cb !== callback
    );
  }

  async emit<K extends keyof T>(event: K, payload: T[K]): Promise<void> {
    const listeners = this.listeners[event] || [];
    await Promise.all(listeners.map((cb) => cb(payload)));
  }
}
